export default "__VITE_ASSET__DPvjaS7M__"